import styled from 'styled-components';

import {
  Colors,
} from '@noitada/shared/constants';



export const PaymentChooseContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;



export const PaymentInfoChooseView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 10px;
`;

export const PaymentChooseTitle = styled.h1`
  margin-bottom: 4px;
  color: ${Colors.textApp};
  font-size: 14px;
  font-weight: 400;
`;

export const PaymentChooseCardNumber = styled.h2`
  color: ${Colors.white};
  font-size: 19px;
  font-weight: bold;
  line-height: 24px;
`;

export const PaymentChooseInstallment = styled.h1`
  margin-bottom: 4px;
  color: ${Colors.textApp};
  font-size: 14px;
  font-weight: 400;
`;

export const PaymentChooseSubtitle = styled.p`
  margin-top: 4px;
  color: ${Colors.gray};
  font-size: 13px;
  line-height: 16px;
`;
